<template>
  <div class="landscape-guide" v-if="showLandscapeGuide">
    <van-overlay :show="true" :lock-scroll="true">
      <div class="guide-container">
        <div class="guide-animation">
          <div class="guide-anim anim-arrow">
            <img
              src="~@/assets/images/common/landscape-guide/arrow.png"
              alt=""
            />
          </div>
          <div class="guide-anim anim-phone-horizon">
            <img
              src="~@/assets/images/common/landscape-guide/phone1.png"
              alt=""
            />
          </div>
          <div class="guide-anim anim-phone-vertical">
            <img
              src="~@/assets/images/common/landscape-guide/phone2.png"
              alt=""
            />
          </div>
        </div>
        <div class="guide-text">
          {{ $t('common.landscape_guide') }}
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState(['showLandscapeGuide']),
    },
  }
</script>

<style lang="scss" scoped>
  .landscape-guide {
    .van-overlay {
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      background-color: rgba(0, 0, 0, 0.95);
    }

    .guide-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .guide-animation {
      width: px2vh(280);
      height: px2vh(248);
      position: relative;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .guide-anim {
        position: absolute;
      }

      .anim-arrow {
        width: px2vh(54);
        height: px2vh(64);
        left: px2vh(24);
        top: px2vh(7);
        opacity: 0;
        animation: fadeIn 0.2s ease-in-out 0.84s forwards;
      }
      .anim-phone-horizon {
        width: px2vh(248);
        height: px2vh(140);
        left: 0;
        bottom: 0;
        opacity: 0;
        animation: fadeIn 0.2s ease-in-out 0.4s forwards;
      }
      .anim-phone-vertical {
        width: px2vh(140);
        height: px2vh(248);
        right: 0;
        bottom: 0;
        opacity: 0;
        transform-origin: 0% 100%;
        animation: moveFadeIn 0.6s ease-in-out 0.6s forwards;
      }
    }

    .guide-text {
      margin-top: px2vh(45);
      max-width: px2vh(800);
      word-break: break-word;
      font-family: 'Roboto';
      font-weight: 500;
      font-size: px2vh(39);
      line-height: 1.17;
      text-align: center;

      background: radial-gradient(
        90% 8871.43% at 50% 50%,
        #ffffff 0%,
        #ffffff 20%,
        rgba(255, 255, 255, 0.33) 80%,
        rgba(255, 255, 255, 0.33) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      opacity: 0;
      animation: fadeIn 0.4s ease-in-out 0.65s forwards;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    @keyframes moveFadeIn {
      0% {
        opacity: 0;
        right: px2vh(-108);
        transform: rotate(-90deg);
      }
      33% {
        opacity: 1;
      }
      100% {
        opacity: 1;
        right: 0px;
        transform: rotate(0deg);
      }
    }
  }
</style>
